import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {RoomParty} from '../../../graphql/groups.datatypes';

interface RoomPartiesData {
    roomPartiesUnderMaxOccupancy: RoomParty[],
}

export const gqlRoomParty = `
    id
    members {
        primary_occupant
        groupMember {
            id
            first_name
            last_name
        }
    }
`;

export const GET_ROOM_PARTIES_QUERY = gql`
  query roomPartiesUnderMaxOccupancy($group_id: Int!, $room_party_id: Int!){
      roomPartiesUnderMaxOccupancy(group_id: $group_id, room_party_id: $room_party_id){
        ${gqlRoomParty}
    }
  }
`;

export const getRoomPartiesUnderMaxOccupancy = (group_id: number, room_party_id: number) => useQuery<RoomPartiesData>(
    GET_ROOM_PARTIES_QUERY,
    {
        variables: {
            group_id,
            room_party_id,
        },
    }
);

export default getRoomPartiesUnderMaxOccupancy;
